<h5>System Settings <small>(Id: {{currentUser?.clientId}})</small></h5>
<form [formGroup]="clientSettingsForm" *ngIf="clientSettingsForm">
  <!--  <span class="title"> Client Settings </span>-->
  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="65%">
      <mat-form-field appearance="outline">
        <mat-label>Client Name {{filteredTimeZones.length}} -- {{filteredTimeZones.length > 0}}</mat-label>
        <input matInput placeholder="" formControlName="clientName">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Time Zone</mat-label>
        <mat-select formControlName="clientTimezone">
          <mat-option>
            <ngx-mat-select-search [formControl]="tzFilterCtrl" [placeholderLabel]="'Search Timezones'">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let tz of filteredTimeZones" [value]="tz.key">{{tz.value}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Default Role for Manager Users</mat-label>
        <mat-select formControlName="defaultManagerUserRole">
          <mat-option *ngFor="let role of roles" [value]="role.roleId">{{role.roleName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Default Role for Insight Users</mat-label>
        <mat-select formControlName="defaultInsightUserRole">
          <mat-option *ngFor="let role of roles" [value]="role.roleId">{{role.roleName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Default Views for Manager Users</mat-label>
        <mat-select multiple formControlName="defaultManagerUserViewIds">
          <mat-option *ngFor="let view of views" value="{{view.viewId}}">{{view.viewName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Default Views for Insight Users</mat-label>
        <mat-select multiple formControlName="defaultInsightUserViewIds">
          <mat-option *ngFor="let view of views" value="{{view.viewId}}">{{view.viewName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Benchmarks Enable?</mat-label>
        <mat-select formControlName="hasBenchMarks">
          <mat-option *ngFor="let v of [{k :'yes', v: 'Yes'}, {k : 'no', v: 'No'}]" value="{{v.k}}">{{v.v}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Features Enabled</mat-label>
        <mat-select multiple formControlName="featureWhiteList">
          <mat-option *ngFor="let v of features" value="{{v}}">{{v | humanize}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Session Expiry</mat-label>
        <mat-select formControlName="tokenExpiryInMinutes">
          <mat-option *ngFor="let o of tokenExpiryOptions" value="{{o.k}}">{{o.v}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxFlex="32%">
      <div style="padding: 4% 2%;">
        <mat-checkbox formControlName="portalSurveyLinkExpire">
          Portal Links Expire
        </mat-checkbox>
      </div>
    </div>

    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Portal Link Expiration</mat-label>
        <input type="number" min="30" max="1000" matInput placeholder="Portal Links will expiration."
          formControlName="portalSurveyLinkExpirationDays">
        <span matTextSuffix>Days</span>
      </mat-form-field>
    </div>


    <!-- div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Email Alerts Enabled</mat-label>
        <mat-select formControlName="needsSurveyResponseEscalation">
          <mat-option [value]=1>Yes</mat-option>
          <mat-option [value]=0>No</mat-option>
        </mat-select>
      </mat-form-field>
    </div -->
  </div>
  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-checkbox formControlName="insightsEnabled">Insights Enabled</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="calendarQuartersDisabled">Calender Quarters Disabled</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="compareWidgetsEnabled">Compare Widgets Enabled</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="showConfidenceInWidgets" title="Shows a confidence indicator (margin of error) on supported widgets, e.g. the NPS widget's confidence bar">Show Confidence in Widgets</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Confidence Level</mat-label>
        <mat-select formControlName="confidenceLevel">
          <mat-option *ngFor="let o of confidenceLevelOptions" [value]="o.name">{{ o.title }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Denominator Multiplier</mat-label>
        <input matInput type="number" min="0" step="0.01" formControlName="denominatorMultiplier"
               title="Multiplies the sample size used in the confidence indicator's margin-of-error calc, to correct for clients with many data exclusions configured">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="smsEnabled">SMS Enabled</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="forcePwdChange" title="Force users to change password every 90 days">Force Change
        Password Enabled</mat-checkbox>
    </div>
    <div fxFlex="32%">
      <mat-checkbox formControlName="enableLiveSession" title="Track Live Session">Track Live Session</mat-checkbox>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>SMS Number</mat-label>
        <input matInput placeholder="" formControlName="smsNumber">
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Users</mat-label>
        <input matInput placeholder="" formControlName="users">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Views</mat-label>
        <input matInput placeholder="" formControlName="views">
      </mat-form-field>
    </div>
    <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Country</mat-label>
        <input matInput placeholder="" formControlName="operatingCountry">
      </mat-form-field>
    </div>
    <!-- <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>ATS Auth Provider</mat-label>
        <mat-select formControlName="atsAuthProvider">
          <mat-option value="Smart Recruiters">Smart Recruiters</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <!-- <div fxFlex="32%">
      <mat-form-field appearance="outline">
        <mat-label>Index Calculation on Surveys Tab</mat-label>
        <mat-select formControlName="indexCalculations">
          <mat-option value="widgets">From Widgets (responsive to filters)</mat-option>
          <mat-option value="database">Locked with Dashboard</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
  </div>
  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="49%">
      <mat-form-field appearance="outline">
        <mat-label>Teams Welcome Message</mat-label>
        <textarea matInput placeholder="" rows="6" formControlName="teamsWelcomeMessage"></textarea>
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row wrap" class="settings-row" fxLayoutGap="10px">
    <div fxFlex="49%">
      <mat-form-field appearance="outline">
        <mat-label>Slack Welcome Message</mat-label>
        <textarea matInput placeholder="" rows="6" formControlName="slackWelcomeMessage"></textarea>
      </mat-form-field>
    </div>
  </div>

</form>
<form [formGroup]="slackBotForm" *ngIf="slackBotForm">
  <h5>Slack Bot Settings</h5>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    <div fxFlex="98%">
      <mat-form-field appearance="outline">
        <mat-label>Slack Bot User OAuth Token</mat-label>
        <input readonly matInput placeholder="" formControlName="botUserOAuthToken">
        <span matSuffix style="vertical-align: super;">This cannot be edited</span>
      </mat-form-field>
    </div>
  </div>
</form>
